import { render, staticRenderFns } from "./TaskRTWCTemplate.vue?vue&type=template&id=7bdbbb86&scoped=true&lang=pug"
import script from "./TaskRTWCTemplate.vue?vue&type=script&lang=ts"
export * from "./TaskRTWCTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdbbb86",
  null
  
)

export default component.exports